/* ==========================================================
   COZMETICA — BRANDS DIRECTORY PAGE
   Save as: assets/cozmetica-brands-page.js
   No dependencies. Runs per-section (theme-editor safe).
   ========================================================== */
(function () {
  'use strict';

  function initBrandsPage(root) {
    var searchInput = root.querySelector('#cbp-search-input');
    var searchClear = root.querySelector('#cbp-search-clear');
    var chips = root.querySelectorAll('.cbp-chip');
    var cards = root.querySelectorAll('.cbp-card');
    var alphaBtns = root.querySelectorAll('.cbp-alpha-btn:not(.is-disabled)');
    var countEl = root.querySelector('#cbp-count');
    var emptyEl = root.querySelector('#cbp-empty');
    var emptyReset = root.querySelector('#cbp-empty-reset');
    var grid = root.querySelector('#cbp-grid');

    var state = { query: '', filter: 'all', country: null, letter: null };

    function applyFilters() {
      var visibleCount = 0;
      var q = state.query.trim().toLowerCase();

      cards.forEach(function (card) {
        var name = (card.getAttribute('data-name') || '').toLowerCase();
        var isFeatured = card.getAttribute('data-featured') === 'true';
        var country = card.getAttribute('data-country') || '';
        var letter = card.getAttribute('data-letter') || '';

        var matchesQuery = q === '' || name.indexOf(q) !== -1;
        var matchesFilter = true;
        if (state.filter === 'featured') matchesFilter = isFeatured;
        if (state.filter === 'country') matchesFilter = country === state.country;
        var matchesLetter = state.letter === null || letter === state.letter;

        var visible = matchesQuery && matchesFilter && matchesLetter;
        card.hidden = !visible;
        if (visible) visibleCount++;
      });

      countEl.textContent = visibleCount + (visibleCount === 1 ? ' brand' : ' brands');
      emptyEl.hidden = visibleCount !== 0;
      grid.hidden = visibleCount === 0;
      searchClear.hidden = state.query === '';
    }

    // Search
    if (searchInput) {
      searchInput.addEventListener('input', function (e) {
        state.query = e.target.value;
        applyFilters();
      });
    }
    if (searchClear) {
      searchClear.addEventListener('click', function () {
        searchInput.value = '';
        state.query = '';
        searchInput.focus();
        applyFilters();
      });
    }

    // Chips
    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        chips.forEach(function (c) { c.classList.remove('is-active'); });
        chip.classList.add('is-active');
        state.filter = chip.getAttribute('data-filter');
        state.country = chip.getAttribute('data-country') || null;
        applyFilters();
      });
    });

    // Empty state reset
    if (emptyReset) {
      emptyReset.addEventListener('click', function () {
        searchInput.value = '';
        state.query = '';
        state.filter = 'all';
        state.country = null;
        state.letter = null;
        chips.forEach(function (c) { c.classList.remove('is-active'); });
        root.querySelector('.cbp-chip[data-filter="all"]').classList.add('is-active');
        root.querySelectorAll('.cbp-alpha-btn').forEach(function (b) { b.classList.remove('is-active'); });
        applyFilters();
      });
    }

    // A–Z filter — click a letter to show only those brands, click again to clear
    alphaBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var letter = btn.getAttribute('data-letter');
        var alreadyActive = btn.classList.contains('is-active');

        alphaBtns.forEach(function (b) { b.classList.remove('is-active'); });

        if (alreadyActive) {
          state.letter = null;
        } else {
          btn.classList.add('is-active');
          state.letter = letter;
        }

        applyFilters();

        if (state.letter) {
          var firstMatch = root.querySelector('.cbp-card[data-letter="' + letter + '"]:not([hidden])');
          if (firstMatch) firstMatch.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      });
    });

    applyFilters();
  }

  document.querySelectorAll('.cbp').forEach(initBrandsPage);

  // Theme editor support: re-init on section load
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('.cbp');
    if (root) initBrandsPage(root);
  });
})();
